export const calculateExtensionsTimes = (items, minutes, isFirstTreatment) => {
  if (minutes <= 0) return 0;

  const extensionsTimes = {
    first_treatment: 0,
    pain_management: 0,
    larger_surface_area: 0,
    shaving_assistance: 0,
    total: 0,
  };
  let extensionsTimesTotal = 0;
  // ***** Pain Management Logic ***** //
  // See if any area is checked for pain management
  const isPainManagementChecked =
    items.filter((item) => item.isPainManagementChecked).length > 0; // True OR False
  // Based off of total treatment time to be scheduled.  10 minutes: no time added, 20 minutes to 60 minutes: 10 minutes, Over 60 minutes to 2 hours: 20 minutes maximum
  if (isPainManagementChecked) {
    extensionsTimes.pain_management +=
      minutes >= 20 && minutes <= 60 ? 10 : minutes > 60 ? 20 : 0;
  }

  // ***** Shaving Assistance Logic ***** //
  // See how many areas are checked for shaving assistance
  const shavingAssistanceItems = items
    .filter((item) => item.isShavingAssistanceChecked)
    .map((item) => item.shaving_assistance);
  // Additional Time: +10 minutes for areas requiring shaving assistance. It cannot exceed 20 minutes
  if (shavingAssistanceItems.length > 0) {
    extensionsTimes.shaving_assistance +=
      shavingAssistanceItems.length >= 2 ? 20 : 10;
  }

  // ***** Larger Surface Area Logic ***** //
  // See how many areas are checked for larger surface area
  const largerAreasItems = items
    .filter((item) => item.isLargerAreaChecked)
    .map((item) => item.larger_surface_area);
  // It cannot exceed 20 minutes
  if (largerAreasItems.length > 0) {
    extensionsTimes.larger_surface_area +=
      largerAreasItems.length >= 2 ? 20 : largerAreasItems[0];
  }

  extensionsTimesTotal =
    extensionsTimes.pain_management +
    extensionsTimes.shaving_assistance +
    extensionsTimes.larger_surface_area;
  if (extensionsTimesTotal > 20) {
    extensionsTimesTotal = 20;
  }

  // ***** First Treatment Logic ***** //
  extensionsTimes.first_treatment = isFirstTreatment ? 5 : 0;
  extensionsTimesTotal += extensionsTimes.first_treatment;

  // ***** Add 5 minutes to the First Treatment ***** //
  //  extensionsTime.total += extensionsTimes.first_treatment;

  return { extensionsTimes, extensionsTimesTotal };
};
